import { authFetch } from '../../../auth'
import { buildPriceListApiUrl } from './priceListUrlHelpers'

export const priceListBackend = async (
  BASE_BACKEND_URL,
  body,
  evaluateResponse,
  isEditing = false,
  priceListId = null
) => {
  const url = isEditing
    ? buildPriceListApiUrl(BASE_BACKEND_URL, 'price_lists', priceListId)
    : buildPriceListApiUrl(BASE_BACKEND_URL, 'price_lists')

  const method = isEditing ? 'PATCH' : 'POST'

  const response = await authFetch(url, {
    method,
    body: JSON.stringify(body),
  })

  evaluateResponse(response)
}

export const cancelCreate = (event) => {
  event.preventDefault()
  return window.confirm(
    '¿Está seguro que quiere continuar? Los cambios no serán guardados.'
  )
}
